import { computed, watch } from "vue";
import { nowLang } from "../language";
import { useStore } from "vuex";
import { INIT_LANGUAGE_LIST, FETCH_SURVEY } from "../store/modules/survey/actions";
import { CHECK_LOGIN } from "../store/modules/user/actions";
import { resultState } from "./resultHook";
import {
  collectInfo,
  commonAnswerInfo,
  singleEditInfo,
  checkTips,
} from "./answerHook";
import { popupState } from "./popupHook";
import {
  SET_CHOOSE_ANSWER,
  SET_CURRENT_MATRIX_PAGE_INDEX,
  SET_MATRIX_ANSWER,
  UPDATE_ENTRY_QUESTION_TIME,
} from "../store/modules/survey/mutations";
import { INIT_SERVER_LIST } from "../store/modules/user/actions";
import { checkHasHistory } from "./historyHook";
import { useRouter } from "vue-router";
import { getParam } from "../utils";
import { language } from "../language";

// 初始化答案数据
const initAnswerData = (
  store,
  currentResultType,
  currentQuestionType,
  currentAnswerConfig,
  isMatrixType
) => {
  if (currentResultType.value !== "common") return;

  commonAnswerInfo.value = [];
  const matrixAnswer = [];

  const dataMap = {
    singleChoose: currentAnswerConfig.value,
    multipleChoose: currentAnswerConfig.value?.list,
    matrixSingle: currentAnswerConfig.value?.rowTitleArray,
    matrixProgress: currentAnswerConfig.value?.rowTitleArray,
    NPS: new Array(11),
  };

  const forTarget = dataMap[currentQuestionType.value] || [];
  for (let i = 0; i < forTarget.length; i++) {
    commonAnswerInfo.value.push({
      chooseIndex: i,
      edit: "",
      rowId: forTarget[i]?.id,
    });
    matrixAnswer.push(-1);
  }

  store.commit(`survey/${SET_CHOOSE_ANSWER}`, []);
  store.commit(`survey/${SET_MATRIX_ANSWER}`, []);
  store.commit(`survey/${SET_CURRENT_MATRIX_PAGE_INDEX}`, 0);
  if (isMatrixType.value) {
    store.commit(`survey/${SET_MATRIX_ANSWER}`, matrixAnswer);
  }
};

// 重置收集信息
const resetCollectInfo = () => {
  singleEditInfo.value = "";
  collectInfo.value.phone = "";
  collectInfo.value.email = "";
  collectInfo.value.phoneArea = "";
};

export default async function () {
  const store = useStore();
  const router = useRouter();

  // ========== Computed 定义 ==========
  const currentResultType = computed(
    () => store.getters["survey/currentResultType"]
  );
  const currentQuestionType = computed(
    () => store.getters["survey/currentQuestionType"]
  );
  const currentAnswerConfig = computed(
    () => store.getters["survey/currentAnswerConfig"]
  );
  const isMatrixType = computed(() => store.getters["survey/isMatrixType"]);

  // ========== 路由守卫 ==========
  if (store.state.survey.currentIndex === -1) {
    router.push("/");
  }

  // ========== 初始化语言列表 ==========
  await store.dispatch(`survey/${INIT_LANGUAGE_LIST}`);

  // ========== 检查登录状态并初始化 ==========
  try {
    await store.dispatch(`user/${CHECK_LOGIN}`);
    // 埋点上报
    window.surveyDataLayer.push({
      eventName: "view_page",
      loginAccount: store.state.user.username,
      serverId:
        getParam("serverId") || getParam("server_id") || getParam("serverID"),
      roleId: getParam("roleId") || getParam("role_id") || getParam("roleID"),
      roleName: getParam("role_name") || getParam("roleName"),
    });
  } catch (error) {
    console.error("检查登录状态失败:", error);
  }

  //  ========== 监听语言变化，获取问卷信息 ==========
  watch(
    () => nowLang.value,
    async () => {
      const result = await store.dispatch(`survey/${FETCH_SURVEY}`, nowLang.value);

      if (result.success) {
        // 如果已作答，但未领奖或者为序列号发奖，则直接引导到结果页
        if (
          store.state.survey.isAnswer &&
          (!store.state.survey.isAward || resultState.showType === "series")
        ) {
          router.push("/result");
        }

        // 如果为礼包发奖，则初始化服务器列表
        if (resultState.showType === "award" && store.state.user.isLogin) {
          await store.dispatch(`user/${INIT_SERVER_LIST}`);
        }

        // 当问卷在生效期间则检验是否存在历史记录
        if (
          store.state.survey.canSurveyTimeStart &&
          !store.state.survey.isSurveyEnd &&
          store.state.survey.latestEditTime
        ) {
          checkHasHistory(store.state.survey.latestEditTime);
        }
      } else {
        const code = result.code;
        if (code != null && String(code).trim() !== "") {
          popupState.tips = `${language.getTextByCode(String(code))}[${code}]`;
        } else {
          popupState.tips = language.getTextByCode('common');
        }

      }
    },
    { immediate: true }
  );

  // ========== 监听题目切换 ==========
  watch(
    () => store.state.survey.currentIndex,
    (newValue, oldValue) => {
      // 切换题目滚动到顶部
      const questionDom = document.getElementById("question");
      if (questionDom) {
        questionDom.scrollTop = 0;
      }

      // 初始化验证提示语
      checkTips.value = "";

      // 如果是返回上一题则不需要初始化答案数据
      if (newValue < oldValue) {
        return;
      }

      // 初始化重置答案数据
      initAnswerData(
        store,
        currentResultType,
        currentQuestionType,
        currentAnswerConfig,
        isMatrixType
      );

      // 重置收集信息
      resetCollectInfo();

      // 更新进入题目时间
      store.commit(`survey/${UPDATE_ENTRY_QUESTION_TIME}`, new Date());
    }
  );
}
